import ReadingSheet from './ReadingSheet';
import './ReadingSettings.css';

const SIZES = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
  { value: 'extra-large', label: 'Extra large' }
];

const FORMATS = [
  { value: 'text', label: 'Plain' },
  { value: 'html', label: 'Formatted' }
];

const TOGGLES = [
  { key: 'verseNumbers', label: 'Verse numbers' },
  { key: 'headings', label: 'Section headings' },
  { key: 'footnotes', label: 'Footnotes' }
];

/** Text size, format and ESV extras, tucked behind the toolbar's Aa button. */
const ReadingSettings = ({ open, onClose, prefs, onChange }) => (
  <ReadingSheet open={open} onClose={onClose} title="Text settings">
    <fieldset className="settings-group">
      <legend>Text size</legend>
      <div className="settings-segmented">
        {SIZES.map(size => (
          <button
            key={size.value}
            type="button"
            className={`settings-size settings-size--${size.value}`}
            aria-pressed={prefs.fontSize === size.value}
            aria-label={size.label}
            onClick={() => onChange({ fontSize: size.value })}
          >
            A
          </button>
        ))}
      </div>
    </fieldset>

    <fieldset className="settings-group">
      <legend>Layout</legend>
      <div className="settings-segmented">
        {FORMATS.map(format => (
          <button
            key={format.value}
            type="button"
            aria-pressed={prefs.format === format.value}
            onClick={() => onChange({ format: format.value })}
          >
            {format.label}
          </button>
        ))}
      </div>
    </fieldset>

    <fieldset className="settings-group">
      <legend>Show</legend>
      {TOGGLES.map(toggle => (
        <label key={toggle.key} className="settings-toggle">
          <span>{toggle.label}</span>
          <input
            type="checkbox"
            checked={prefs[toggle.key]}
            onChange={(e) => onChange({ [toggle.key]: e.target.checked })}
          />
        </label>
      ))}
    </fieldset>
  </ReadingSheet>
);

export default ReadingSettings;
